import EdgeSourceAdditionalInfo from "Areas/SharedFeatures/types/edgeSourceAdditionalInfo";
import head from "lodash/head";
import map from "lodash/map";
import uniq from "lodash/uniq";
class GroupEdgesSource extends EdgeSourceAdditionalInfo {
    constructor(GroupId, Edges) {
        var _a, _b, _c;
        super();
        this.GroupId = GroupId;
        this.Edges = Edges;
        this.Edges.forEach(edge => {
            edge.GroupId = this.GroupId;
        });
        this.Created = (_a = head(this.Edges)) === null || _a === void 0 ? void 0 : _a.Created;
        const from = uniq(map(this.Edges, "From"));
        if (from.length === 1) {
            this.From = head(from);
        }
        else {
            this.FromGroup = (_b = head(this.Edges)) === null || _b === void 0 ? void 0 : _b.FromGroup;
        }
        const to = uniq(map(this.Edges, "To"));
        if (to.length === 1) {
            this.To = head(to);
        }
        else {
            this.ToGroup = (_c = head(this.Edges)) === null || _c === void 0 ? void 0 : _c.ToGroup;
        }
    }
}
export default GroupEdgesSource;
